'use client';

import { useEffect, useState, type JSX } from 'react';
import { Button, Dialog, DialogCloseTrigger } from '@chakra-ui/react';

import { confirmModalEvent } from './event';

import type { IConfirmProps } from './interface';

const defaultProps: IConfirmProps = {
  title: 'Are you sure?',
};

export function ConfirmModal(): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [props, setProps] = useState<IConfirmProps>(defaultProps);

  const close = () => {
    setIsOpen(false);
    setIsLoading(false);
    setProps(defaultProps);
  };

  useEffect(() => {
    function openConfirm(params: IConfirmProps = {}) {
      setIsOpen(true);
      setProps({
        ...defaultProps,
        ...params,
      });
    }

    confirmModalEvent.on('confirm', openConfirm);

    return () => {
      confirmModalEvent.removeListener('confirm', openConfirm);
    };
  }, []);

  const { title, getLoading, onSubmit } = props;

  const submit = () => {
    onSubmit?.({
      close,
    });

    setIsLoading(getLoading?.() ?? false);
  };

  return (
    <Dialog.Root
      open={isOpen}
      closeOnEscape
      placement='center'
      motionPreset='slide-in-bottom'
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Header>
            <Dialog.Title>{title}</Dialog.Title>
          </Dialog.Header>
          <Dialog.Footer gap={3}>
            <Button onClick={close} colorPalette='red'>
              No
            </Button>
            <Button onClick={submit} colorPalette='teal' loading={isLoading}>
              Yes
            </Button>
          </Dialog.Footer>
          <DialogCloseTrigger onClick={close} />
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
